/* eslint-disable react/display-name */
import React, { memo, useEffect, useRef } from 'react';
import ngDeps from '../../common/utilities/ngDependencies';
import { withScreenSize } from '../common/utilities/withScreenSize.jsx';

interface UpdateDynamicBgImageProps {
    isMobile: boolean;
    isTablet: boolean;
    isDesktop: boolean;
}

export const UpdateDynamicBgImage = withScreenSize(memo(({ isDesktop, isTablet, isMobile }: UpdateDynamicBgImageProps) => {
    const prevScreenType = useRef<keyof UpdateDynamicBgImageProps | null>(null);

    useEffect(() => {
        let currentScreenType: keyof UpdateDynamicBgImageProps =  'isDesktop';
        if (isTablet) {
            currentScreenType = 'isTablet';
        } else if (isMobile) {
            currentScreenType = 'isMobile';
        }
        if (prevScreenType.current && prevScreenType.current !== currentScreenType) {
            ngDeps?.rootScope?.App?.updateBackground?.();
        }
        prevScreenType.current = currentScreenType;
    }, [isDesktop, isTablet, isMobile]);
  
    return null;
}));
